<script lang="ts">
import { Avatar as AvatarPrimitive } from 'bits-ui';
import type { Snippet } from 'svelte';

let { children, ...restProps }: AvatarPrimitive.FallbackProps & { children?: Snippet } = $props();
</script>

<AvatarPrimitive.Fallback
  style="display: flex; height: 100%; width: 100%; align-items: center; justify-content: center; border-radius: 50%; font-size: 11px; font-weight: 600;"
  {...restProps}
>
  {@render children?.()}
</AvatarPrimitive.Fallback>
